module.exports = __webpack_public_path__ + "assets/img/question.52dc8a64.svg";